export const getMenuData = [
  {
    category: true,
    title: 'Dashboards',
  },
  {
    title: 'Dashboard Alpha',
    key: 'dashboard',
    icon: 'fe fe-home',
    url: '/dashboard/alpha',
    // roles: ['admin'], // set user roles with access to this route
  },
  {
    title: 'Dashboard Gamma',
    key: 'adminDashboard',
    icon: 'fe fe-home',
    url: '/dashboard/gamma',
    roles: ['admin'],
  },
  {
    category: true,
    title: 'Lists',
  },
  {
    title: 'Saved Questions',
    key: 'list0',
    icon: 'fa fa-bookmark',
    url: '/lists/saved',
  },
  {
    category: true,
    title: 'Content',
  },
  {
    title: 'Foundations of Nursing',
    key: 'category1',
    icon: 'fe fe-database',
    children: [
      {
        title: 'Professional Standards',
        key: 'topic1',
        url: '/content/study/1/1',
      },
      {
        title: 'Foundations of Care',
        key: 'topic2',
        url: '/content/study/2/1',
      },
    ],
  },
  {
    title: 'Maternal and Child Health',
    key: 'category2',
    icon: 'fe fe-database',
    children: [
      {
        title: 'Growth and Development',
        key: 'topic3',
        url: '/content/study/3/1',
      },
      {
        title: 'Maternity Nursing',
        key: 'topic4',
        url: '/content/study/4/1',
      },
      {
        title: 'Pediatric Nursing',
        key: 'topic5',
        url: '/content/study/5/1',
      },
    ],
  },
  {
    title: 'Community Health',
    key: 'category3',
    icon: 'fe fe-hard-drive',
    children: [
      {
        title: 'Complex Care',
        key: 'topic6',
        url: '/content/study/6/1',
      },
    ],
  },
  {
    title: 'Care of Adults and Aged',
    key: 'category4',
    icon: 'fe fe-hard-drive',
    children: [
      {
        title: 'Integumentary Problems',
        key: 'topic7',
        url: '/content/study/7/1',
      },
      {
        title: 'Oncological and Hematological Problems',
        key: 'topic8',
        url: '/content/study/8/1',
      },
      {
        title: 'Endocrine Problems',
        key: 'topic9',
        url: '/content/study/9/1',
      },
      {
        title: 'Gastrointestinal Problems',
        key: 'topic10',
        url: '/content/study/10/1',
      },
      {
        title: 'Respiratory Problems',
        key: 'topic11',
        url: '/content/study/11/1',
      },
      {
        title: 'Cardiovascular Problems',
        key: 'topic12',
        url: '/content/study/12/1',
      },
      {
        title: 'Renal and Urinary Problems',
        key: 'topic13',
        url: '/content/study/13/1',
      },
      {
        title: 'Eye and Ear Problems',
        key: 'topic14',
        url: '/content/study/14/1',
      },
      {
        title: 'Neurological Problems',
        key: 'topic15',
        url: '/content/study/15/1',
      },
      {
        title: 'Musculoskeletal Problems',
        key: 'topic16',
        url: '/content/study/16/1',
      },
      {
        title: 'Immune Problems',
        key: 'topic17',
        url: '/content/study/17/1',
      },
    ],
  },
  {
    title: 'Mental Health',
    key: 'category5',
    icon: 'fe fe-hard-drive',
    children: [
      {
        title: 'Mental Health',
        key: 'topic18',
        url: '/content/study/18/1',
      },
    ],
  },
  {
    title: 'Bonus Questions',
    key: 'category6',
    icon: 'fe fe-hard-drive',
    children: [
      {
        title: 'Practice Questions',
        key: 'topic19',
        url: '/content/study/19/1',
      },
    ],
  },
]
